import {ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import * as FileSaver from 'file-saver';
import {FileRestService} from '../../../../../shared/services/common/file/file-rest.service';
import {FileUtilsService} from '../../../../../shared/services/common/file/file-utils.service';
import {TranslateService} from '@ngx-translate/core';
import * as moment from 'moment';

@Component({
  selector: 'wsd-report',
  templateUrl: './report.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./report.component.css']
})
export class ReportComponent implements OnChanges {

  @Input()
  organizationId: number;

  @Input()
  title: string;

  @Input()
  fileId: number;

  @Input()
  date: Date;

  @Input()
  year: number;

  notUploadedLabel: string;

  isOlderReport = false;

  isOlderThanYear: boolean;

  constructor(private fileRestService: FileRestService,
              private fileUtils: FileUtilsService,
              private translate: TranslateService) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.isOlderReport = false;
    const currentDate = moment();
    this.isOlderThanYear = this.year !== (currentDate.year() - 1);
    if (this.year) {
      const firstDateOfTheReportYear = new Date((this.year + 1), 0, 1);
      if (moment().isAfter(firstDateOfTheReportYear)) {
        const duration = moment.duration(currentDate.startOf('year').diff(firstDateOfTheReportYear));
        // WOSM-15: SHOW ONLY MORE THEN ONE YEAR
        // if (duration.asDays() >= 1) {
        //   this.setUploadedLabel('DATA_PORTAL.ANNUAL_REPORTING.NOT_UPLOADED_DAY', duration.asDays());
        //   this.isOlderReport = true;
        // }
        // if (duration.asDays() >= 31 && duration.asMonths() >= 1) {
        //   this.setUploadedLabel('DATA_PORTAL.ANNUAL_REPORTING.NOT_UPLOADED_MONTH', duration.asMonths());
        //   this.isOlderReport = true;
        // }
        if (duration.asDays() >= 365 && duration.asYears() >= 1 ) {
          this.setUploadedLabel('DATA_PORTAL.ANNUAL_REPORTING.NOT_UPLOADED_YEAR', duration.asYears());
          this.isOlderReport = true;
        }
      }
    } else {
      this.setUploadedLabel('DATA_PORTAL.ANNUAL_REPORTING.NOT_UPLOADED');
      this.isOlderReport = true;
    }
  }

  getSummaryNote(id: number) {
    this.fileRestService.getFile(id).subscribe(
      (response: any) => FileSaver.saveAs(response.body, this.fileUtils.extractFileName(response)),
    );
  }

  setUploadedLabel(label: string, duration?: number) {
    this.notUploadedLabel = this.translate.instant(label, {date: Math.floor(duration)});
  }

}
